import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Modal, Row, Navbar, Col, Label, Input } from "reactstrap";
import * as controller from "../../../controllers/aceiteCpController";
import * as actions from "../../../store/modules/aceiteCp/actions";
import { Select } from "../../../components/Inputs/Input";
import { notifyWarn } from "../../../components/message/message";
import { maskMoeda } from "../../../util/masks";
import { tiposPagamento } from "../constants/aceite";
import "./style.css";

const ModalEditar = ({ toggle, isOpen, pagination }) => {
  const {
    filtroAplicado,
    sistemas,
    modalEdicao,
    selectedItems,
  } = useSelector((state) => state.aceiteCp);

  const [isSalvando, setIsSalvando] = useState(false);

  const tipoPagamento = tiposPagamento.find(
    (tipo) => tipo.id === modalEdicao.tipoRegraId
  );

  async function handleConfirmar() {
    if (isSalvando) return;

    if(modalEdicao.sistemaId !== "0") {
        setIsSalvando(true);
        const success = await controller.aceite({
          ids: selectedItems.map((selecionado) => selecionado.id),
          campanhaPremiacaoTipoRegraId: modalEdicao.tipoRegraId,
          campanhaPremiacaoSistemaIntegracaoId: modalEdicao.sistemaId,
        });

        if (success) {
          actions.setSelectedItems([]);
          actions.setModalEdicaoField("0", "sistemaId");
          await controller.get(pagination.page, pagination.pageSize, filtroAplicado);
          toggle();
          return;
        }
        setIsSalvando(false);
    } else {
        notifyWarn("Selecione um sistema");
    }
  }

  const onChange = (value, field) => {
    actions.setModalEdicaoField(value, field);
  };

  useEffect(() => {
    actions.setModalEdicaoField("0", "sistemaId");
  }, []);

  return (
    <div>
      <Modal
        className="text-center"
        isOpen={isOpen}
        toggle={toggle}
        backdrop={true}
        size="lg"
      >
        <Navbar
          expand="md"
          className="w-100 mb-2 aceite-cp-modal-header"
        >
          <h5 className="mx-auto mt-2 text-white">Aceite dados</h5>
        </Navbar>
        <div className="container-fluid my-3">
          <Row>
            <Col md={4}>
              <Label>Tipo Pagamento</Label>
              <Select
                first="Selecione"
                value={{ value: modalEdicao.tipoRegraId }}
                select={{ value: "id", label: "descricao" }}
                options={tiposPagamento}
                isSearchable={true}
                autoComplete="off"
                disabled
              />
            </Col>
            <Col md={4}>
              <Label>Sistema</Label>
              <Select
                first="Selecione"
                value={{ value: modalEdicao.sistemaId }}
                select={{ value: "id", label: "nome" }}
                options={sistemas}
                onChange={(e) => {
                  onChange(e.value, "sistemaId");
                }}
                isSearchable={true}
                autoComplete="off"
              />
            </Col>
            <Col md={4}>
              <Label>
                Valor {tipoPagamento ? tipoPagamento.descricao : ""} a aceitar
              </Label>
              <Input
                type="text"
                value={maskMoeda(modalEdicao.valor?.toFixed(2))}
                disabled
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <p className="aceite-cp-modal-itens">
                Itens selecionados: <strong>{selectedItems.length}</strong>
              </p>
              <p className="aceite-cp-modal-aviso">
                Atenção: o aceite é irreversível.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-center mt-5">
            <Col md={2}>
              <Button
                className="aceite-cp-modal-botao aceite-cp-modal-botao-cancelar"
                onClick={() => {
                  toggle();
                }}
              >
                Cancelar
              </Button>
            </Col>
            <Col md={2}>
              <Button
                className="purpleButton aceite-cp-modal-botao"
                disabled={isSalvando}
                onClick={() => {
                  handleConfirmar();
                }}
              >
                Salvar
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default ModalEditar;
